import { lazy, Suspense } from 'preact/compat';
import { Router, Route, route } from 'preact-router';
import { useEffect } from 'preact/hooks';

import Error from './commons/Error';
import Loading from './commons/Loading';

const UserDetailsContainer = lazy(() => import('./user-details/UserDetailsContainer'));
const SSOContainer = lazy(() => import('./sso/SSOContainer'));
const ResetPasswordRequest = lazy(() => import('./sso/Login/Okta/ResetPasswordRequest'));
const ResetPasswordEmail = lazy(() => import('./sso/Login/Okta/ResetPasswordEmail'));
const Authorize = lazy(() => import('./sso/Authorize'));
const ResetPassword = lazy(() => import('./sso/ResetPassword'));
const PrivacyPolicy = lazy(() => import('./sso/PrivacyPolicy'));

// Redirect component for handling redirects
const RedirectToLogin = () => {
  useEffect(() => {
    route('/session/login', true);
  }, []);

  return null;
};

const App = () => (
  <Suspense
    fallback={
      <div className="flex h-screen items-center justify-center">
        <Loading />
      </div>
    }
  >
    <Router>
      {/* Redirect from root to login */}
      <Route path="/" component={RedirectToLogin} />

      {/* Main routes - using explicit any casting for now */}
      <Route path="/user/:rest*" component={UserDetailsContainer} />
      <Route path="/session/:rest*" component={SSOContainer} />
      <Route path="/forgot-password" component={ResetPasswordRequest} />
      <Route path="/forgot-password/check-email" component={ResetPasswordEmail} />
      <Route path="/api/oauth/authorize" component={Authorize} />
      <Route path="/reset-password/:token" component={ResetPassword} />
      <Route path="/user-notice" component={PrivacyPolicy} />

      {/* Catch-all route for 404s */}
      <Route default component={Error} />
    </Router>
  </Suspense>
);

export default App;
